const importAll = r => {
  let cache = {};
  r.keys().map(key => (cache[key] = r(key)));

  return cache;
};

export default importAll;
